define('shared/util/providers/data/Math',['shared/util/registers/DataProvider', 'shared/lib/RSVP', 'shared/util/Math'], 
function(DataProvider, RSVP, Math){
    'use strict';

    var done;

    return {
        provide: function(){
            if ( done ) {
                return done;
            }

            done = RSVP.resolve()
                .then(function(){
                    var provider = {
                        id: 'Math',
                        value: function(){
                            return Math;
                        }
                    };
                    DataProvider.instance.register( provider );
                });

            return done;
        }
    };
});


